import { Controller } from "@hotwired/stimulus";
import { EditorView, basicSetup } from "codemirror";
import { EditorState } from "@codemirror/state";
import { html } from "@codemirror/lang-html";
import { liquid } from "@codemirror/lang-liquid";
import { javascript } from "@codemirror/lang-javascript";
import { css } from "@codemirror/lang-css";
import { DirectUpload } from "@rails/activestorage";

export default class extends Controller {
  static targets = ["assetEditor", "source"];
  static values = {
    srcUrl: String,
    srcType: String,
    srcName: String,
  };

  connect() {
    console.log("asset editor");
    let docSrc;
    if (this.hasSrcUrlValue) {
      docSrc = "Loading...";
    } else {
      docSrc = this.sourceTarget.value;
    }
    this.codeMirrorView = new EditorView({
      doc: docSrc,
      extensions: [basicSetup, html(), liquid(), javascript(), css()],
      parent: this.assetEditorTarget,
      dispatch: this.assetEditorUpdated.bind(this),
    });
    this.load();
  }

  assetEditorUpdated(transaction) {
    this.codeMirrorView.update([transaction]);
  }

  async load() {
    try {
      const response = await fetch(this.srcUrlValue);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const assetSrc = await response.text();

      const newState = EditorState.create({
        doc: assetSrc,
      });

      this.codeMirrorView.dispatch({
        changes: {
          from: 0,
          to: this.codeMirrorView.state.doc.length,
          insert: assetSrc,
        },
      });
    } catch (error) {
      console.error("Failed to load code:", error);
    }
  }

  saveAsset() {
    console.log("saveCode");
    const assetSource = this.codeMirrorView.state.doc.toString();
    const blob = new Blob([assetSource], { type: this.srcTypeValue });
    const file = new File([blob], this.srcNameValue, {
      type: this.srcTypeValue,
    });
    const upload = new DirectUpload(
      file,
      "/rails/active_storage/direct_uploads"
    );
    upload.create((error, blob) => {
      if (error) {
        console.error("Upload failed:", error);
      } else {
        // Attach blob.signed_id to a hidden input for form submission
        const hiddenInput = document.createElement("input");
        hiddenInput.setAttribute("type", "hidden");
        hiddenInput.setAttribute("name", "account_asset[file]"); // Your param name
        hiddenInput.setAttribute("value", blob.signed_id);

        this.element.appendChild(hiddenInput);

        // Optionally, submit the form automatically
        this.element.closest("form").submit();
      }
    });
  }
}
